// Carrello lato client (localStorage). Regola: un solo venditore/struttura per ordine.
const KEY = "yp_cart";

export function getCart() {
  try { return JSON.parse(localStorage.getItem(KEY)) || null; } catch { return null; }
}
export function cartCount() {
  const c = getCart();
  return c ? c.items.reduce((n, i) => n + i.qty, 0) : 0;
}
export function clearCart() { localStorage.removeItem(KEY); window.dispatchEvent(new Event("cart-changed")); }

// Ritorna { ok } oppure { conflict: true, currentOrg } se il prodotto è di un'altra struttura.
export function addToCart(orgId, orgName, item, force = false) {
  let c = getCart();
  if (c && c.org_id !== orgId) {
    if (!force) return { conflict: true, currentOrg: c.org_name };
    c = null;
  }
  if (!c) c = { org_id: orgId, org_name: orgName, items: [] };
  const key = `${item.product_id}::${item.variant_id || ""}`;
  const existing = c.items.find((i) => `${i.product_id}::${i.variant_id || ""}` === key);
  if (existing) existing.qty += item.qty;
  else c.items.push(item);
  localStorage.setItem(KEY, JSON.stringify(c));
  window.dispatchEvent(new Event("cart-changed"));
  return { ok: true };
}
export function setQty(productId, variantId, qty) {
  const c = getCart(); if (!c) return;
  const it = c.items.find((i) => i.product_id === productId && (i.variant_id || "") === (variantId || ""));
  if (it) { it.qty = Math.max(1, qty); localStorage.setItem(KEY, JSON.stringify(c)); window.dispatchEvent(new Event("cart-changed")); }
}
export function removeItem(productId, variantId) {
  const c = getCart(); if (!c) return;
  c.items = c.items.filter((i) => !(i.product_id === productId && (i.variant_id || "") === (variantId || "")));
  if (c.items.length === 0) clearCart();
  else { localStorage.setItem(KEY, JSON.stringify(c)); window.dispatchEvent(new Event("cart-changed")); }
}
